import { createSlice } from '@reduxjs/toolkit';

import { initSucceeded } from '../../actions/cabinListActions';

// Replaces rather than merges, as the old reducer did.
const accommodationSlice = createSlice({
  name: 'accommodation',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initSucceeded, (_state, action) => ({
      hotels: action.payload.hotels,
      numberOfHotelNights: action.payload.numberOfHotelNights,
    }));
  },
});

export default accommodationSlice.reducer;
